// extracted by mini-css-extract-plugin
export default {"comment":"CreateComment_comment__ArQta"};